import React from 'react';
import { Modal as AntModal } from "antd";
import {omit} from 'lodash';
import './Modal.less';
export default class Modal extends AntModal{

    render() {
        const {className} = this.props;
        const props = omit(this.props, ['className'])
        return (
            <AntModal {...props} className={`hms-modal ${className || ''}`}>{this.props.children}</AntModal>
        )
    }
}